"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ERR_FAILED_TO_FETCH_OPENID_CLAIMS_DESCRIPTION = exports.ERR_FAILED_TO_FETCH_OPENID_CLAIMS = exports.ERR_OPENID_CHECK_SESSION_ERROR_DESCRIPTION = exports.ERR_OPENID_CHECK_SESSION_ERROR = exports.ERR_FAILED_TO_VALIDATE_OPENID_METADATA_DESCRIPTION = exports.ERR_FAILED_TO_VALIDATE_OPENID_METADATA = exports.ERR_FAILED_TO_PARSE_OPENID_METADATA_DESCRIPTION = exports.ERR_FAILED_TO_PARSE_OPENID_METADATA = exports.ERR_FAILED_TO_FETCH_OPENID_METADATA_DESCRIPTION = exports.ERR_FAILED_TO_FETCH_OPENID_METADATA = exports.ERR_REGISTRATION_NOT_SUPPORTED_DESCRIPTION = exports.ERR_REGISTRATION_NOT_SUPPORTED = exports.ERR_REQUEST_URI_NOT_SUPPORTED_DESCRIPTION = exports.ERR_REQUEST_URI_NOT_SUPPORTED = exports.ERR_REQUEST_NOT_SUPPORTED_DESCRIPTION = exports.ERR_REQUEST_NOT_SUPPORTED = exports.ERR_INVALID_REQUEST_OBJECT_DESCRIPTION = exports.ERR_INVALID_REQUEST_OBJECT = exports.ERR_INVALID_REQUEST_URI_DESCRIPTION = exports.ERR_INVALID_REQUEST_URI = exports.ERR_CONSENT_REQUIRED_DESCRIPTION = exports.ERR_CONSENT_REQUIRED = exports.ERR_ACCOUNT_SELECTION_REQUIRED_DESCRIPTION = exports.ERR_ACCOUNT_SELECTION_REQUIRED = exports.ERR_LOGIN_REQUIRED_DESCRIPTION = exports.ERR_LOGIN_REQUIRED = exports.ERR_INTERACTION_REQUIRED_DESCRIPTION = exports.ERR_INTERACTION_REQUIRED = exports.ERR_TEMPORARILY_UNAVAILABLE_DESCRIPTION = exports.ERR_TEMPORARILY_UNAVAILABLE = exports.ERR_SERVER_ERROR_DESCRIPTION = exports.ERR_SERVER_ERROR = exports.ERR_INVALID_SCOPE_DESCRIPTION = exports.ERR_INVALID_SCOPE = exports.ERR_UNSUPPORTED_RESPONSE_TYPE_DESCRIPTION = exports.ERR_UNSUPPORTED_RESPONSE_TYPE = exports.ERR_ACCESS_DENIED_DESCRIPTION = exports.ERR_ACCESS_DENIED = exports.ERR_UNAUTHORIZED_CLIENT_DESCRIPTION = exports.ERR_UNAUTHORIZED_CLIENT = exports.ERR_INVALID_REQUEST_DESCRIPTION = exports.ERR_INVALID_REQUEST = exports.ERR_RENEW_TIMEOUT_DESCRIPTION = exports.ERR_RENEW_TIMEOUT = exports.ERR_UNAUTHORIZED_DESCRIPTION = exports.ERR_UNAUTHORIZED = exports.ERR_UNSUPPORTED_TOKEN_TYPE_DESCRIPTION = exports.ERR_UNSUPPORTED_TOKEN_TYPE = exports.ERR_STATE_MISMATCH_DESCRIPTION = exports.ERR_STATE_MISMATCH = void 0;
exports.ERR_FAILED_TO_VALIDATE_OPENID_CLAIMS_DESCRIPTION = exports.ERR_FAILED_TO_VALIDATE_OPENID_CLAIMS = exports.ERR_FAILED_TO_PARSE_OPENID_CLAIMS_DESCRIPTION = exports.ERR_FAILED_TO_PARSE_OPENID_CLAIMS = void 0;
/**
 * Authorization server response validation error.
 *
 * Unable to verify the validity of the request by matching
 * the "state" parameter sent with the authorization request
 * to the "state" parameter received in authorization server
 * response.
 *
 * This error may indicate a cross-site request forgery (CSRF)
 * attack or a misconfiguration of the authorization server.
 *
 * See: https://tools.ietf.org/html/rfc6749#section-10.12
 */
exports.ERR_STATE_MISMATCH = 'state_mismatch';
exports.ERR_STATE_MISMATCH_DESCRIPTION = "\n  This error may indicate a cross-site request forgery (CSRF)\n  attack or a misconfiguration of the authorization server.\n";
/**
 * Authorization server response validation error.
 *
 * SGWTConnect does not support the access token type
 * received from the authorization server.
 */
exports.ERR_UNSUPPORTED_TOKEN_TYPE = 'unsupported_token_type';
exports.ERR_UNSUPPORTED_TOKEN_TYPE_DESCRIPTION = "\n  SGWTConnect does not support the access token type\n  received from the authorization server.\n";
/**
 * SGWTConnect unauthorized error.
 *
 * Occurs when SGWTConnect is unable to perform an action
 * because it is currently unauthorized to do so.
 */
exports.ERR_UNAUTHORIZED = 'unauthorized';
exports.ERR_UNAUTHORIZED_DESCRIPTION = "\n  SGWTConnect is unable to perform an action\n  because it is currently unauthorized to do so.\n";
/**
 * SGWTConnect renewal error.
 *
 * Occurs when SGWTConnect does not receive a response
 * from the authorization server while renewing the token.
 */
exports.ERR_RENEW_TIMEOUT = 'renew_timeout';
exports.ERR_RENEW_TIMEOUT_DESCRIPTION = "\n  SGWTConnect did not receive a response\n  from the authorization server while\n  renewing the token.\n";
//
// OAuth 2.0 errors are listed below.
// See: https://tools.ietf.org/html/rfc6749#section-4.2.2.1
// --------------------
/**
 * Authorization server error response.
 *
 * The request is missing a required parameter, includes an
 * unsupported parameter value, includes a parameter more
 * than once, or is otherwise malformed.
 *
 * See: https://tools.ietf.org/html/rfc6749#section-4.2.2.1
 */
exports.ERR_INVALID_REQUEST = 'invalid_request';
exports.ERR_INVALID_REQUEST_DESCRIPTION = "\n  The configuration may be malformed.\n  Double check all configuration options.\n";
/**
 * Authorization server error response.
 *
 * The client is not authorized to request an access token
 * using this method.
 *
 * See: https://tools.ietf.org/html/rfc6749#section-4.2.2.1
 */
exports.ERR_UNAUTHORIZED_CLIENT = 'unauthorized_client';
exports.ERR_UNAUTHORIZED_CLIENT_DESCRIPTION = "\n  The client is not authorized to request an access token\n  using this method.\n";
/**
 * Authorization server error response.
 *
 * The resource owner or authorization server denied the request.
 *
 * See: https://tools.ietf.org/html/rfc6749#section-4.2.2.1
 */
exports.ERR_ACCESS_DENIED = 'access_denied';
exports.ERR_ACCESS_DENIED_DESCRIPTION = "\n  The resource owner or authorization server denied the request.\n";
/**
 * Authorization server error response.
 *
 * The authorization server does not support obtaining an
 * access token using this method.
 *
 * See: https://tools.ietf.org/html/rfc6749#section-4.2.2.1
 */
exports.ERR_UNSUPPORTED_RESPONSE_TYPE = 'unsupported_response_type';
exports.ERR_UNSUPPORTED_RESPONSE_TYPE_DESCRIPTION = "\n  The authorization server does not support obtaining an\n  access token using this method.\n\n  Double-check the \"response_type\" configuration option.\n";
/**
 * Authorization server error response.
 *
 * The requested scope is invalid, unknown, or malformed.
 *
 * See: https://tools.ietf.org/html/rfc6749#section-4.2.2.1
 */
exports.ERR_INVALID_SCOPE = 'invalid_scope';
exports.ERR_INVALID_SCOPE_DESCRIPTION = "\n  The requested scope is invalid, unknown, or malformed.\n";
/**
 * Authorization server error response.
 *
 * The authorization server encountered an unexpected
 * condition that prevented it from fulfilling the request.
 * (This error code is needed because a 500 Internal Server
 * Error HTTP status code cannot be returned to the client
 * via an HTTP redirect.)
 *
 * See: https://tools.ietf.org/html/rfc6749#section-4.2.2.1
 */
exports.ERR_SERVER_ERROR = 'server_error';
exports.ERR_SERVER_ERROR_DESCRIPTION = "\n  The authorization server encountered an unexpected\n  condition that prevented it from fulfilling the request.\n\n  Please try again in a few minutes.\n";
/**
 * Authorization server error response.
 *
 * The authorization server is currently unable to handle
 * the request due to a temporary overloading or maintenance
 * of the server. (This error code is needed because a 503
 * Service Unavailable HTTP status code cannot be returned
 * to the client via an HTTP redirect.)
 *
 * See: https://tools.ietf.org/html/rfc6749#section-4.2.2.1
 */
exports.ERR_TEMPORARILY_UNAVAILABLE = 'temporarily_unavailable';
exports.ERR_TEMPORARILY_UNAVAILABLE_DESCRIPTION = "\n  The authorization server is currently unable to handle\n  the request due to a temporary overloading or maintenance\n  of the server.\n\n  Please try again in a few minutes.\n";
//
// OpenID Connect 1.0 errors are listed below.
// See: http://openid.net/specs/openid-connect-core-1_0.html#AuthError
// --------------------
/**
 * OpenID Connect authentication error response.
 *
 * The Authorization Server requires End-User interaction
 * of some form to proceed. This error MAY be returned
 * when the prompt parameter value in the Authentication Request
 * is none, but the Authentication Request cannot be completed
 * without displaying a user interface for End-User interaction.
 *
 * See: http://openid.net/specs/openid-connect-core-1_0.html#AuthError
 */
exports.ERR_INTERACTION_REQUIRED = 'interaction_required';
exports.ERR_INTERACTION_REQUIRED_DESCRIPTION = "\n  The Authorization Server requires End-User interaction\n  of some form to proceed.\n";
/**
 * OpenID Connect authentication error response.
 *
 * The Authorization Server requires End-User authentication.
 * This error MAY be returned when the prompt parameter value in the
 * Authentication Request is none, but the Authentication Request
 * cannot be completed without displaying a user interface for
 * End-User authentication.
 *
 * See: http://openid.net/specs/openid-connect-core-1_0.html#AuthError
 */
exports.ERR_LOGIN_REQUIRED = 'login_required';
exports.ERR_LOGIN_REQUIRED_DESCRIPTION = "\n  The Authorization Server requires End-User authentication.\n";
/**
 * OpenID Connect authentication error response.
 *
 * The End-User is REQUIRED to select a session at the Authorization Server.
 * The End-User MAY be authenticated at the Authorization Server with
 * different associated accounts, but the End-User did not select a session.
 * This error MAY be returned when the prompt parameter value in the
 * Authentication Request is none, but the Authentication Request
 * cannot be completed without displaying a user interface to prompt
 * for a session to use.
 *
 * See: http://openid.net/specs/openid-connect-core-1_0.html#AuthError
 */
exports.ERR_ACCOUNT_SELECTION_REQUIRED = 'account_selection_required';
exports.ERR_ACCOUNT_SELECTION_REQUIRED_DESCRIPTION = "\n  The End-User is REQUIRED to select a session at the Authorization Server.\n  The End-User MAY be authenticated at the Authorization Server with\n  different associated accounts, but the End-User did not select a session.\n";
/**
 * OpenID Connect authentication error response.
 *
 * The Authorization Server requires End-User consent.
 * This error MAY be returned when the prompt parameter value in the
 * Authentication Request is none, but the Authentication Request
 * cannot be completed without displaying a user interface for
 * End-User consent.
 *
 * See: http://openid.net/specs/openid-connect-core-1_0.html#AuthError
 */
exports.ERR_CONSENT_REQUIRED = 'consent_required';
exports.ERR_CONSENT_REQUIRED_DESCRIPTION = "\n  The Authorization Server requires End-User consent.\n";
/**
 * OpenID Connect authentication error response.
 *
 * The request_uri in the Authorization Request returns an error
 * or contains invalid data.
 *
 * See: http://openid.net/specs/openid-connect-core-1_0.html#AuthError
 */
exports.ERR_INVALID_REQUEST_URI = 'invalid_request_uri';
exports.ERR_INVALID_REQUEST_URI_DESCRIPTION = "\n  The request_uri in the Authorization Request returns an error\n  or contains invalid data.\n\n  This is probably a bug in SGWTConnect.\n";
/**
 * OpenID Connect authentication error response.
 *
 * The request parameter contains an invalid Request Object.
 *
 * See: http://openid.net/specs/openid-connect-core-1_0.html#AuthError
 */
exports.ERR_INVALID_REQUEST_OBJECT = 'invalid_request_object';
exports.ERR_INVALID_REQUEST_OBJECT_DESCRIPTION = "\n  The request parameter contains an invalid Request Object.\n\n  This is probably a bug in SGWTConnect.\n";
/**
 * OpenID Connect authentication error response.
 *
 * The OpenID Provider does not support use of the `request` parameter defined in
 * [Section 6](http://openid.net/specs/openid-connect-core-1_0.html#JWTRequests).
 *
 * See: http://openid.net/specs/openid-connect-core-1_0.html#AuthError
 */
exports.ERR_REQUEST_NOT_SUPPORTED = 'request_not_supported';
exports.ERR_REQUEST_NOT_SUPPORTED_DESCRIPTION = "\n  The OpenID Provider does not support use of the \"request\" parameter.\n";
/**
 * OpenID Connect authentication error response.
 *
 * The OpenID Provider does not support use of the `request_uri` parameter defined in
 * [Section 6](http://openid.net/specs/openid-connect-core-1_0.html#JWTRequests).
 *
 * See: http://openid.net/specs/openid-connect-core-1_0.html#AuthError
 */
exports.ERR_REQUEST_URI_NOT_SUPPORTED = 'request_uri_not_supported';
exports.ERR_REQUEST_URI_NOT_SUPPORTED_DESCRIPTION = "\n  The OpenID Provider does not support use of the \"request_uri\" parameter.\n";
/**
 * OpenID Connect authentication error response.
 *
 * The OpenID Provider does not support use of the `registration` parameter defined in
 * [Section 7.2.1](http://openid.net/specs/openid-connect-core-1_0.html#RegistrationParameter).
 *
 * See: http://openid.net/specs/openid-connect-core-1_0.html#AuthError
 */
exports.ERR_REGISTRATION_NOT_SUPPORTED = 'registration_not_supported';
exports.ERR_REGISTRATION_NOT_SUPPORTED_DESCRIPTION = "\n  The OpenID Provider does not support use of the \"registration\" parameter.\n";
//
// OpenID Connect 1.0 Session Management errors are listed below.
// See: https://openid.net/specs/openid-connect-session-1_0.html
// --------------------
/**
 * Indicates that an HTTP request to obtain
 * the OpenID Provider Discovery Metadata has failed.
 */
exports.ERR_FAILED_TO_FETCH_OPENID_METADATA = 'failed_to_obtain_openid_metadata';
exports.ERR_FAILED_TO_FETCH_OPENID_METADATA_DESCRIPTION = "\n  Failed to obtain OpenID Provider Metadata.\n";
/**
 * Indicates that there was a error parsing
 * the OpenID Provider Discovery Metadata response.
 */
exports.ERR_FAILED_TO_PARSE_OPENID_METADATA = 'failed_to_parse_openid_metadata';
exports.ERR_FAILED_TO_PARSE_OPENID_METADATA_DESCRIPTION = "\n  Failed to parse OpenID Provider Discovery Metadata.\n";
/**
 * Indicates that there was an error validating
 * the OpenID Provider Discovery Metadata response.
 */
exports.ERR_FAILED_TO_VALIDATE_OPENID_METADATA = 'failed_to_validate_openid_metadata';
exports.ERR_FAILED_TO_VALIDATE_OPENID_METADATA_DESCRIPTION = "\n  Failed to validate OpenID Provider Discovery Metadata.\n";
/**
 * Indicates that the OpenID OP iframe received
 * a syntactically malformed message.
 *
 * See: https://openid.net/specs/openid-connect-session-1_0.html#OPiframe
 */
exports.ERR_OPENID_CHECK_SESSION_ERROR = 'check_session_error';
exports.ERR_OPENID_CHECK_SESSION_ERROR_DESCRIPTION = "\n  Client ID and origin URL cannot be determined or are syntactically invalid.\n";
//
// OpenID UserInfo Endpoint.
// See: https://openid.net/specs/openid-connect-core-1_0.html#UserInfo
// --------------------
/**
 * Indicates that an HTTP request to obtain
 * the OpenID UserInfo Claims has failed.
 */
exports.ERR_FAILED_TO_FETCH_OPENID_CLAIMS = 'failed_to_obtain_openid_claims';
exports.ERR_FAILED_TO_FETCH_OPENID_CLAIMS_DESCRIPTION = "\n  Failed to obtain OpenID UserInfo Claims.\n";
/**
 * Indicates that there was a error parsing
 * the OpenID UserInfo Claims response.
 */
exports.ERR_FAILED_TO_PARSE_OPENID_CLAIMS = 'failed_to_parse_openid_claims';
exports.ERR_FAILED_TO_PARSE_OPENID_CLAIMS_DESCRIPTION = "\n  Failed to parse OpenID UserInfo Claims.\n";
/**
 * Indicates that there was an error validating
 * the OpenID UserInfo Claims response.
 */
exports.ERR_FAILED_TO_VALIDATE_OPENID_CLAIMS = 'failed_to_validate_openid_claims';
exports.ERR_FAILED_TO_VALIDATE_OPENID_CLAIMS_DESCRIPTION = "\n  Failed to validate OpenID UserInfo Claims.\n";
